module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasContent) ? _c('article', {
    staticClass: "content-container node-page"
  }, [_c('h2', {
    staticClass: "article-title",
    class: {
      'show-title': _vm.showTitle, 'hide-title': !_vm.showTitle
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.isAdmin) ? _c('div', {
    staticClass: "edit-bar"
  }, [_c('div', {
    staticClass: "edit",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.editNode(_vm.content.nid)
      }
    }
  }, [_vm._v("Edit")])]) : _vm._e(), _vm._v(" "), (_vm.content.hasImage) ? [_c('vue-picture', {
    attrs: {
      "imgset": _vm.content.image,
      "sizes": _vm.fullSizes,
      "className": _vm.content.image.attributes.className
    }
  })] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "body",
    domProps: {
      "innerHTML": _vm._s(_vm.content.body)
    }
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-691c8997"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Node.vue
// module id = 339
// module chunks = 1